import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined'
import Tooltip from 'antd/lib/tooltip'
import { useCallback, useEffect, useState } from 'react'
import { OnElapsedParams, Timer } from 'Core/Timer'
import { toMinTwoDigits } from 'Utils/common.utils'
import './TimerDisplay.less'

export type TimerDisplayProps = {
    timer: Timer
    handleTimerClick?: () => void
}

export const TimerDisplay = (props: TimerDisplayProps) => {
    const [timer, setTimer] = useState('00:00')
    useEffect(() => {
        const eventId = props.timer.onElapsed((elapsedTime: OnElapsedParams) => {
            const elapsedTimeDisplay = `${toMinTwoDigits(elapsedTime.minutes)}:${toMinTwoDigits(
                elapsedTime.seconds
            )}`
            setTimer(elapsedTimeDisplay)
        })
        return () => {
            props.timer.offElapsed(eventId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleTimerClick = useCallback(() => {
        props.handleTimerClick?.()
    }, [props])

    return (
        <Tooltip title="Time elapsed on the active task">
            <button
                className="timer-root"
                data-testid="timer-wrapper"
                onClick={() => handleTimerClick()}
            >
                <ClockCircleOutlined style={{ fontSize: 16, marginRight: 8 }} />
                <span>{timer}</span>
            </button>
        </Tooltip>
    )
}
